import { useEffect, useState } from "react";
import { hasConsent, setConsent } from "../utils/cookieConsent";
import "../assets/css/CookieConsent.css";

function CookieIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <circle cx="8.5" cy="8.5" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="15" cy="10" r="1" fill="currentColor" stroke="none" />
      <circle cx="10" cy="15" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="15.5" cy="15.5" r=".9" fill="currentColor" stroke="none" />
    </svg>
  );
}

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!hasConsent()) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = (value) => {
    setConsent(value);
    setVisible(false);
    window.dispatchEvent(new CustomEvent("vasiCookieConsent", { detail: value }));
  };

  return (
    <div className={`vasi-cc-wrap${visible ? " vasi-cc-visible" : ""}`} role="dialog" aria-label="Cookie preferences" aria-live="polite">
      <div className="vasi-cc-card">
        <div className="vasi-cc-top">
          <div className="vasi-cc-icon">
            <CookieIcon />
          </div>
          <div className="vasi-cc-text">
            <div className="vasi-cc-title">We value your privacy</div>
            <div className="vasi-cc-desc">
              We use cookies to personalise content and analyse traffic. Analytics cookies are only activated with your consent.{" "}
              <a href="/privacy-policy-usa" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </div>
          </div>
        </div>
        <div className="vasi-cc-divider" />
        <div className="vasi-cc-actions">
          <button className="vasi-cc-btn vasi-cc-btn--reject" type="button" onClick={() => dismiss("none")}>
            Reject all
          </button>
          <button className="vasi-cc-btn vasi-cc-btn--essential" type="button" onClick={() => dismiss("essential")}>
            Essential only
          </button>
          <button className="vasi-cc-btn vasi-cc-btn--accept" type="button" onClick={() => dismiss("all")}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;